import React from 'react';

// @ts-ignore
import FormManager from 'src/core/gd-form/common/form-manager';
import FieldManagementFormProto from "../../../../proto/render/management/management-form";
import {FieldManagementFormProps} from "../../../../render/management-form";

export default class FieldCheckbox_ManagementForm extends FieldManagementFormProto {

    constructor(props:FieldManagementFormProps) {
        super(props);

        // important to have it here !
        this.formStructure.onSubmit = this.onSubmit;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit = (result:any) => {
        super.onSubmit(result);

        // custom settings here

        this.props.onSubmit(this.props.field);
    }

}